import { FormEvent, useState } from 'react'
import { Key } from 'react-aria'
import { useNavigate } from 'react-router'
import { Client, Reservation } from '../../shared/types'
import { useReservationCreate } from '../api/reservations'
import { AresModal } from '../components/ares-modal'
import { Button } from '../components/button'
import { ChildObject } from '../components/child-object'
import { Input } from '../components/input'
import { Switch } from '../components/switch'
import { useFormLayout } from '../layouts'
import { FormLayout } from '../layouts/form-layout'

export function Form({
	data,
	onClose,
	redirect,
}: {
	data?: Partial<Reservation>
	onClose?: VoidFunction
	redirect?: boolean
}) {
	const { layout } = useFormLayout('reservation', 'create')
	const { mutate: create, isPending } = useReservationCreate()
	const navigate = useNavigate()

	const onSubmit = (e: FormEvent<HTMLFormElement>) => {
		e.stopPropagation()
		e.preventDefault()
		create(new FormData(e.currentTarget), {
			onSuccess(id) {
				onClose?.()
				if (redirect) {
					navigate('/svc/reservation/' + id)
				}
			},
		})
	}

	const [clientId, setClientId] = useState<Key | null>(null)
	const [ico, setIco] = useState('')
	const [icoCallback, setIcoCallback] = useState<(client: Client) => void>()

	return (
		<>
			{ico && icoCallback ? (
				<AresModal
					ico={ico}
					onClose={() => {
						setIco('')
						setIcoCallback(undefined)
					}}
					onCreate={icoCallback}
				/>
			) : null}

			<form
				className="bg-white rounded-xl border border-slate-200 m-auto max-w-[60em]"
				onSubmit={onSubmit}
			>
				<div className="flex justify-between gap-4 px-5 py-4 sm:px-6 sm:py-5">
					<h3 className="text-md font-bold">Vytvořit rezervaci</h3>
				</div>
				<div className="p-5 space-y-4 ">
					<ChildObject
						object="client"
						name="Klient"
						identifier="client_id"
						selectedKey={clientId}
						onSelectionChange={setClientId}
						isRequired
						additionalAction={{
							name: 'ARES',
							action: (ico: string, callback: (client: Client) => void) => {
								setIcoCallback(() => callback)
								setIco(ico)
							},
						}}
					/>
					<FormLayout layout={layout} data={data} />
					<Deposit />
					<Button type="submit" variant="PRIMARY" isPending={isPending}>
						Vytvořit
					</Button>
				</div>
			</form>
		</>
	)
}

function Deposit() {
	const [isFixed, setIsFixed] = useState(false)
	return (
		<>
			<h4 className="text-sm font-bold">Záloha</h4>
			<Switch
				label="Fixní částka"
				isSelected={isFixed}
				onChange={setIsFixed}
				labelBefore="Procenta"
			/>
			{isFixed ? (
				<Input
					name="__depositFixed"
					label="Výše zálohy"
					type="number"
					inputProps={{ min: 0 }}
				/>
			) : (
				<>
					<Input
						name="__depositPercent"
						label="Podíl zálohy (%)"
						type="number"
						inputProps={{ min: 0, max: 100, step: 1, list: '__deposit-options' }}
						defaultValue="20"
					/>
					<datalist id="__deposit-options">
						{DEPOSIT_OPTIONS.map(option => (
							<option value={option} key={option} />
						))}
					</datalist>
				</>
			)}
		</>
	)
}

const DEPOSIT_OPTIONS = [0, 10, 20, 30, 40, 50, 60, 70, 80, 90, 100]
